export const settingsPanel = qs("#settings-panel");
settingsPanel.style.display = "none";
